<template>
  <div class="nav-menu__list active-list" v-if="active">
    <a href="#" @click.prevent="scrollToAnchor('#watch')"><span>Смотреть и видеть </span></a>
    <a href="#" @click.prevent="scrollToAnchor('#details')"><span>Искусство в деталях</span></a>
    <a href="#" @click.prevent="scrollToAnchor('#announcements')"><span>Анонсы</span></a>
    <a href="#" @click.prevent="scrollToAnchor('#product')"><span>Где купить</span></a>
  </div>
</template>

<script>
import {bus} from "../../utils/bus";

export default {
  name: "MenuOpen",
  data() {
    return {
      active: false
    }
  },
  mounted() {
    bus.$on('open-modal', (res) => {
      this.active = res
    })
  },
  methods: {
    scrollToAnchor(name) {
      this.active = !this.active;
      bus.$emit('close-modal',this.active )
      this.$scrollTo(name, {})
    }
  }
}
</script>

<style scoped>

</style>